import { render, staticRenderFns } from "./dropzone-upload.vue?vue&type=template&id=4068a5a0"
import script from "./dropzone-upload.vue?vue&type=script&lang=js"
export * from "./dropzone-upload.vue?vue&type=script&lang=js"
import style0 from "./dropzone-upload.vue?vue&type=style&index=0&id=4068a5a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports